<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Перенести поставщика "№{{supplier.id}}" в список действующих?</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__btns">
					<button class="btn btn--color" @click.prevent="sendForm">Да</button>
					<button class="btn btn--border" @click="$emit('close')">Нет</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Fetch from "@/utils/Fetch";
import {useToast} from "vue-toastification";


export default {
	name: 'AddBlackListPopup',
	props: {
		supplier: {
			type: Object,
			default: () => {}
		},
	},
	data() {
		return {
			toast: useToast(),
		}
	},
	methods: {
		async sendForm() {
			let response = await Fetch(`suppliers/set-status/current/${this.supplier.id}/`, {
				method: 'POST',
			})
			if(response.success) {
				this.toast.success('Поставщик перенесен в список действующих');
				this.$emit('close')
				this.$emit('refreshList')
			} else {
				this.toast.error(response.message);
				this.$emit('close')
			}
		},
	},
}
</script>
